<template>
    <v-container grid-list-xl fluid>
        <v-layout wrap class="mb-12">
            <v-flex xs12 v-if="details">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h5">
                            {{ chargerName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>Carregador</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="details.board" @click="$router.push({ path: `/board/${details.board.name}` });">
                    <v-list-item-icon>
                        <v-icon>local_offer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle><strong>Gateway: </strong>{{ details.board.name }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="chargerData && chargerData.lastNfc">
                    <v-list-item-icon>
                        <v-icon>nfc</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>
                        <strong>Último NFC: </strong>{{ chargerData.lastNfc }}
                    </v-list-item-subtitle>
                    <v-list-item-action>
                        <v-btn small block color="success" class="ma-2 white--text" @click="copy(chargerData.lastNfc)" v-if="chargerData.lastNfc">
                            Copiar
                            <v-icon right dark small> content_copy </v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="details.board && details.board.name && configAdvanced && configAdvanced.server">
                    <v-list-item-icon>
                        <v-icon>vpn_lock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>
                        <ButtonVPN :UUID="details.board.name" :server="configAdvanced.server" />
                    </v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="chargerData">
                    <v-list-item-subtitle>
                        <strong>Última Comunicação do gateway: </strong>{{ chargerData.keepAlive }}
                    </v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="chargerData && chargerData.communication">
                    <v-list-item-subtitle>
                        <strong>Comunicação RS-485 gateway : </strong>{{ chargerData.communication ? "OK" : "Erro" }}
                    </v-list-item-subtitle>
                </v-list-item>
            </v-flex>

            <v-flex xs12>
                <v-progress-linear progress color="primary" :value="timerProgress" />
            </v-flex>

            <v-flex xs12 v-if="configAdvanced">
                <v-btn small v-for="index in configAdvanced.numberPlugs" :key="index" block color="blue-grey" class="white--text my-1" :href="linkNowPlug(index)" target="_blank">
                    <v-icon left>link</v-icon>
                    Plug {{ index }}
                </v-btn>
            </v-flex>

            <v-flex xs12 v-if="config">
                <ExpandPanelSimple title="Configurações" openByDefault barClass="primary darken-1 white--text">
                    <h2 class="primary--text mt-4">Geral</h2>
                    <v-divider class="mb-12 red" style="opacity: 0.22" />

                    <CarConfiguration :data="config" :chargerId="details.id" @saved="$eventHub.$emit('closeSocketOcpp')" />

                    <h2 class="primary--text mt-12">Cadastro</h2>
                    <v-divider class="mb-12 red" style="opacity: 0.22" />

                    <ChargerForm v-if="isAdmin && configAdvanced" :itemToEdit="configAdvanced" :lock="false" @save="init" controlAPI />
                </ExpandPanelSimple>
            </v-flex>

            <v-flex xs12 v-if="config && configAdvanced">
                <ExpandPanelSimple title="Comandos">
                    <CommandOcpp :chargerName="chargerName" :numberPlugs="configAdvanced.numberPlugs" :server="configAdvanced.server" v-if="configAdvanced.protocol == '1.6'" configure />
                    <CommandRelay :UUID="details.board.name" :server="configAdvanced.server" v-if="details.board" />

                    <CommandPayment :chargerName="chargerName" :numberPlugs="configAdvanced.numberPlugs" :server="configAdvanced.server" :config="config" v-if="config && config.stripe" />
                </ExpandPanelSimple>
            </v-flex>

            <v-flex xs12 v-if="isAdmin && details && details.price && configAdvanced">
                <ExpandPanelSimple title="Pagamento">
                    <TestPayment :chargerName="chargerName" :price="details.price" :server="configAdvanced.server" :configAdvanced="configAdvanced" />
                </ExpandPanelSimple>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import CommandRelay from "@/components/shared/CommandRelay";
import CommandOcpp from "@/components/shared/CommandOcpp";
import CommandPayment from "@/components/shared/CommandPayment";
import TestPayment from "@/components/shared/TestPayment";
import ButtonVPN from "@/components/shared/ButtonVPN";
import ExpandPanelSimple from "@/components/core/ExpandPanelSimple.vue";
import CarConfiguration from "@/components/form/CarConfiguration";
import ChargerForm from "@/components/form/Charger";

export default {
    name: "ChargerView",

    components: { CarConfiguration, ExpandPanelSimple, ChargerForm, CommandRelay, CommandOcpp, CommandPayment, TestPayment, ButtonVPN },

    data() {
        return {
            isAdmin: false,
            details: null,
            chargerData: null,
            chargerName: null,
            config: null,
            configAdvanced: null,
            timer: null,
            timerProgress: 100,
        };
    },

    mounted() {
        this.isAdmin = this.verifyRole("ROLE_ADMIN");
        if (this.$route.params.name) {
            this.chargerName = this.$route.params.name.toUpperCase();
        }
        this.init();
        this.update(false);
    },

    created() {
        this.timer = setInterval(this.timerTick, 100);
    },

    computed: {
        ...mapGetters(["verifyRole"]),
    },

    methods: {
        linkNowPlug(plug) {
            return `${window.location.origin}/now/${this.chargerName}/${plug}`;
        },
        copy(text) {
            navigator.clipboard.writeText(text);
            this.$eventHub.$emit("msgSuccess", `Código copiado!!!`);
        },
        timerTick() {
            if (this.timerProgress > 0) {
                this.timerProgress--;
            } else {
                this.update();
                this.timerProgress = 100;
            }
        },
        async init() {
            if (this.chargerName) {
                await this.$http
                    .get(`api/v3/charger/configuration/${this.chargerName}`)
                    .then((result) => {
                        this.details = result;
                    })
                    .catch(() => {
                        this.$eventHub.$emit("msgError", "Erro ao buscar informações.");
                    });
                if (this.details && this.details.id) {
                    await this.$http
                        .get(`api/v3/car/configuration/${this.details.id}`)
                        .then((result) => {
                            this.config = result;
                        })
                    if (this.isAdmin)
                        await this.$http
                            .get(`api/v2/charger/${this.details.id}`)
                            .then((result) => {
                                this.configAdvanced = result;
                            })
                }
            }
        },
        async update(continuous = true) {
            if (this.chargerName) {
                await this.$http
                    .get(`api/v3/charger/details/${this.chargerName}`, { continuous })
                    .then((result) => {
                        this.chargerData = result;
                    }).catch(() => {
                        this.$eventHub.$emit("msgError", "Erro ao buscar informações.");
                    });
            }
        },
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>
